module.exports = __webpack_public_path__ + "img/food.17a2f3d2.png";